import AccountRoot from "@/account/views/AccountRoot.vue";
import AccountRegister from "@/account/views/AccountRegister.vue";
import AccountChangePassword from "@/account/views/AccountChangePassword.vue";
import AccountPreferences from "@/account/views/AccountPreferences.vue";
import AccountDetails from "@/account/views/AccountDetails.vue";
import AccountLogin from "@/account/views/AccountLogin.vue";
import AccountPasswordReset from "@/account/views/AccountPasswordReset.vue";
import AccountStayBookings from "@/account/views/AccountStayBookings.vue";
import AccountSpaBookings from "@/account/views/AccountSpaBookings.vue";
import AccountStayBooking from "@/account/views/AccountStayBooking.vue";
import AccountSpaBooking from "@/account/views/AccountSpaBooking.vue";

import { createWebHashHistory, createRouter } from "vue-router";

import Settings from '@/shared/api/config';
import axios from 'axios';


const AccountRoutes = [
    {
        path: "/login",
        name: "account_login",
        component: AccountLogin
    },
    {
        path: "/password-reset",
        name: "account_password_reset",
        component: AccountPasswordReset
    },

    {
        path: "/register",
        name: "account_register",
        component: AccountRegister
    },
    {
        path: "",
        name: "account_root",
        component: AccountRoot,
        meta: { requiresAuth: true },
        children: [
            {
                path: "/bookings/stay",
                name: "account_stay_bookings",
                component: AccountStayBookings,
                meta: { requiresAuth: true }
            },
            {
                path: "/bookings/spa",
                name: "account_spa_bookings",
                component: AccountSpaBookings,
                meta: { requiresAuth: true }
            },
            {
                path: "/bookings/stay/:id",
                name: "account_stay_booking",
                component: AccountStayBooking,
                meta: { requiresAuth: true }
            },
            //{
            //    path: "/bookings/stay/:id",
            //    name: "account_spa_bookings",
            //    component: AccountStayBooking,
            //    meta: { requiresAuth: true }
            //},
            {
                path: "/bookings/spa/:id",
                name: "account_spa_booking",
                component: AccountSpaBooking,
                meta: { requiresAuth: true }
            },
            {
                path: "/details",
                name: "account_details",
                component: AccountDetails,
                meta: { requiresAuth: true }
            },
            {
                path: "/preferences",
                name: "account_preferences",
                component: AccountPreferences,
                meta: { requiresAuth: true }
            },
            {
                path: "/account/change-password",
                name: "account_change_password",
                component: AccountChangePassword,
                meta: { requiresAuth: true }
            },
        ]
    }
];



const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        ...AccountRoutes
    ],
    scrollBehavior(/*to, from, savedPosition*/) {
        return { top: 0 }
    },

});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        axios.get(Settings.ENDPOINT + 'api/account/validate').then(response => {
            // Token is valid, so continue
            if (to.name == 'account_login') {
                next('/bookings/');
                return;
            } else {
                next();
                return;
            }
        }).catch(error => {
            // There was an error so redirect
            next('/login');
            return;
        });
    } else {
        next();
        return;
    }
});


export default router;
